/**
 * Entry points that receive a bearer credential (reset token, SSO token,
 * OAuth code/state) in the query string. The query is moved into memory and
 * removed from the address bar before any analytics/monitoring SDK starts, so
 * PostHog, LogRocket, Sentry, etc. never see it.
 */
const CREDENTIAL_PATHS = [
  /^\/reset-password\/next\/?$/,
  /^\/signin\/?$/,
  /^\/seller-signin\/?$/
];

let stashedSearch = '';

/**
 * Must run before any SDK is initialised and before the router is created.
 */
export function stashCredentialsFromUrl() {
  const { pathname, search, hash } = window.location;

  if (!search || !CREDENTIAL_PATHS.some(pattern => pattern.test(pathname))) {
    return;
  }

  stashedSearch = search;
  window.history.replaceState(window.history.state, '', pathname + hash);
}

/**
 * Query string captured at page load for a credential entry point, or the
 * router's current search for any other case.
 * @param {string} currentSearch
 */
export function getCredentialSearch(currentSearch = '') {
  return currentSearch || stashedSearch;
}
